export const capUrlConfig = {
  localhost: {
    db: 'http://localhost:8800',
    webApp: 'http://localhost:3000',
  },
  dev: {
    db: 'https://aas-apidev.sbp.eyclienthub.com',
    webApp: 'https://aas-dev.sbp.eyclienthub.com',
  },
  qa: {
    db: 'https://aas-apiqa.sbp.eyclienthub.com',
    webApp: 'https://aas-qa.sbp.eyclienthub.com',
  },
  qa2: {
    db: 'https://aas-apiqa2.sbp.eyclienthub.com',
    webApp: 'https://aas-qa2.sbp.eyclienthub.com',
  },
  stg: {
    db: 'https://aas-stgapi.sbp.eyclienthub.com',
    webApp: 'https://aas-stg.sbp.eyclienthub.com',
  },
  uat: {
    db: 'https://cap-stagingapi.sbp.eyclienthub.com',
    webApp: 'https://cap-staging.sbp.eyclienthub.com',
  },
  prod: {
    db: 'https://ah-api.ey.com',
    webApp: 'https://ah.ey.com',
  },
}

const UAT_REGIONS = [
  // 'aen-eu.sbp.eyclienthub.com',
  'aen-us.sbp.eyclienthub.com']

const PROD_REGIONS = [
  'aen-aue.ey.com',
  'aen-aus.ey.com',
  'aen-cac.ey.com',
  'aen-use2.ey.com',
  'aen-jpe.ey.com',
  'aen-krc.ey.com',
  'aen-eun.ey.com',
  'aen-asa.ey.com',
  'aen-uks.ey.com',
  'aen-euw.ey.com',
  'aen-usw2.ey.com',
]

/**
 * @function: Get current environment of client
 * @returns environment string
 */
export const getCurrentEnv = () => {
  const curUrl = window.location.href
  let environment = 'localhost'
  let region
  if (curUrl.toLowerCase().includes('localhost:3001')) {
    environment = 'localhost'
  } else if (curUrl.toLowerCase().includes('aas-ae-dev.sbp.eyclienthub.com')) {
    environment = 'dev'
  } else if (curUrl.toLowerCase().includes('aen-pt.sbp.eyclienthub.com')) {
    environment = 'stg'
  } else if (curUrl.toLowerCase().includes('aas-ae-qa.sbp.eyclienthub.com')) {
    environment = 'qa'
  } else if (UAT_REGIONS.some((region) => curUrl.toLowerCase().includes(region))) {
    environment = 'uat'
    region = curUrl.split('-')[1].split('.')[0]
  } else if (PROD_REGIONS.some((region) => curUrl.toLowerCase().includes(region))) {
    environment = 'prod'
    region = curUrl.split('-')[1].split('.')[0]
  }
  return {
    environment,
    region,
  }
}

export const getCapBackendUrl = () => {
  const { environment } = getCurrentEnv()
  return capUrlConfig[environment].db
}
